// ** Configs
import endPoint from 'src/configs/endpoints/rekrutmenEndPoints'

// ** Hook Import
import useFetch from 'src/hooks/useFetch'
import useSWR from 'swr'

// ** Type
import { RekrumentDetailResponse } from 'src/types/rekrutmen-detail'

const useRekrutmenDetail = (id?: string) => {
  // ** Hooks
  const { FetchWithPayload } = useFetch()

  const payloadRekrutmenDetail = {
    url: `${endPoint.rekrutmenDetailEndpoint}/${id}`,
    method: 'GET'
  }

  const {
    data,
    isLoading: isLoadingRekrutmenDetail,
    mutate: mutateRekrutmenDetail
  } = useSWR<RekrumentDetailResponse>(
    id ? [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payloadRekrutmenDetail] : null,
    FetchWithPayload
  )

  return {
    dataRekrutmenDetail: data && data.data,
    isLoadingRekrutmenDetail,
    mutateRekrutmenDetail
  }
}

export default useRekrutmenDetail
